import { graphql, useStaticQuery } from 'gatsby';

interface SiteMetadata {
    siteUrl: string;
    title: string;
    description: string;
    author: string;
}

/**
 * Hook to access site metadata including siteUrl
 * The siteUrl is environment-aware:
 * - Development: http://localhost:8000
 * - Production: https://www.servpro.com (or process.env.URL)
 */
const useSiteMetadata = (): SiteMetadata => {
    const { site } = useStaticQuery<Queries.SiteMetadataQuery>(
        graphql`
            query SiteMetadata {
                site {
                    siteMetadata {
                        siteUrl
                        title
                        description
                        author
                    }
                }
            }
        `,
    );

    return site?.siteMetadata as SiteMetadata;
};

export default useSiteMetadata;
